// src/components/ProductionCost.jsx
import React, { useState, useEffect } from "react";
import InvTableTemplate from "./InvTableTemplate";
import { Button, Box, Drawer } from "@mui/material";
import axios from "axios";
import env from "react-dotenv";

const ProductionCost = () => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-cost`);
            setData(response.data); // Assuming the response is an array of production cost records
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleAdd = () => {
        setEditData(null);
        setOpen(true);
    };

    const handleEdit = (item) => {
        setEditData(item);
        setOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-cost/${id}`);
            setData(data.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting record:", error);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async (item) => {
        try {
            if (item.id) {
                await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-cost/${item.id}`, item);
            } else {
                await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-cost`, item);
            }
            fetchData();
        } catch (error) {
            console.error("Error saving record:", error);
        }
        setOpen(false);
    };

    return (
        <Box
            sx={{
                height: 670,
                width: '85%',
                marginLeft: "210px",
                marginRight: "150px",
            }}
        >
            <InvTableTemplate
                columns={["", "plan_id", "product_name", "production_year", "production_month", "planned_quantity", "direct_cost", "indirect_cost", "total_production_cost"]}
                headers={{
                    columns: ["", "Plan ID", "Product Name", "Production Year", "Production Month", "Planned Quantity", "Direct Cost", "Indirect Cost", "Total Production Cost"]
                }}
                iterate={data}
                data={data}
                // onDelete={handleDelete}
                // onEdit={handleEdit}
                // onAdd={handleAdd}
                // add
                // edit
            />

            {/* Drawer for Add/Edit Form */}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                sx={{
                    "& .MuiDrawer-paper": { width: 600 }
                }}
            >
                {/* Add your form component here for adding/editing production cost */}
                {/* <AddEditProductionCost onClose={handleClose} onSave={handleSave} editData={editData} /> */}
            </Drawer>
        </Box>
    );
};

export default ProductionCost;
